<template>
  <v-dialog v-model="dialog" scrollable width="850">
    <v-card>
      <v-toolbar color="primary" dense class="elevation-0" dark>
        <v-toolbar-title>Đăng ký Mượn Thiết bị Trực tuyến</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-4">
        <BorrowForm ref="borrowForm" />
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn outlined @click="cancel">HUỶ</v-btn>
        <v-spacer />
        <v-btn color="primary" @click="save">GỬI YÊU CẦU MƯỢN</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BorrowForm from '@/modules/facility/borrow/BorrowForm.vue'
import { mapActions } from 'vuex'

export default {
  name: 'BorrowNewDialog',
  components: { BorrowForm },
  props: {
    state: Boolean
  },
  data() {
    return {
      dialog: false
    }
  },
  watch: {
    state(val) {
      if (val) this.dialog = true
    }
  },
  methods: {
    ...mapActions('FacilityBorrows', ['createBorrow']),
    cancel() {
      this.dialog = false
      if (this.$refs.borrowForm) {
        this.$refs.borrowForm.resetValidation()
      }
    },
    async save() {
      if (!this.$refs.borrowForm.validate()) return

      this.$loading.active = true
      try {
        const payload = this.$refs.borrowForm.getData()
        await this.createBorrow(payload)
        this.dialog = false
        this.$emit('updated')
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>
